export const VAPID_KEY =
  'BPEP6nBzP7RLAEEx91vAMVK1U8W5BW1YCuULMBMrDc4qeuqzJKvEQmQFqVFY2w4aYEbmMb6Ykg3xQk8fIypd53g';
